import { translate as t } from '@/core/i18n/translate';
import { createReducer } from './utils';
import {
  GET_PLANS_REQUEST,
  GET_PLANS_SUCCESS,
  GET_PLANS_FAILURE,
  CREATE_ANNUAL_PLAN_REQUEST,
  CREATE_ANNUAL_PLAN_SUCCESS,
  CREATE_ANNUAL_PLAN_FAILURE,
  EXPORT_ANNUAL_PLANS_CSV_FAILURE,
  EXPORT_ANNUAL_PLANS_CSV_REQUEST,
  EXPORT_ANNUAL_PLANS_CSV_SUCCESS,
  EXPORT_ANNUAL_PLANS_EXCEL_FAILURE,
  EXPORT_ANNUAL_PLANS_EXCEL_REQUEST,
  EXPORT_ANNUAL_PLANS_EXCEL_SUCCESS,
  ADD_FOCUS_DEFINITION_APPROVAL_REQUEST,
  ADD_FOCUS_DEFINITION_APPROVAL_SUCCESS,
  ADD_FOCUS_DEFINITION_APPROVAL_FAILURE,
  ADD_PLAN_DEFINITION_APPROVAL_REQUEST,
  ADD_PLAN_DEFINITION_APPROVAL_SUCCESS,
  ADD_PLAN_DEFINITION_APPROVAL_FAILURE,
  GET_FOCUS_DEFINITION_APPROVALS_REQUEST,
  GET_FOCUS_DEFINITION_APPROVALS_SUCCESS,
  GET_FOCUS_DEFINITION_APPROVALS_FAILURE,
  GET_PLAN_DEFINITION_APPROVAL_REQUEST,
  GET_PLAN_DEFINITION_APPROVAL_SUCCESS,
  GET_PLAN_DEFINITION_APPROVAL_FAILURE,
  MARK_PLAN_VERSION_FOR_APPROVAL_REQUEST,
  MARK_PLAN_VERSION_FOR_APPROVAL_SUCCESS,
  MARK_PLAN_VERSION_FOR_APPROVAL_FAILURE,
  MARK_PLAN_FULFILLMENT_VERSION_FOR_APPROVAL_REQUEST,
  MARK_PLAN_FULFILLMENT_VERSION_FOR_APPROVAL_SUCCESS,
  MARK_PLAN_FULFILLMENT_VERSION_FOR_APPROVAL_FAILURE,
  CREATE_FULFILLMENT_VERSION_FAILURE,
  CREATE_FULFILLMENT_VERSION_SUCCESS,
  CREATE_FULFILLMENT_VERSION_REQUEST,
  SET_CURRENT_BUSINESS_UNIT,
  SET_CURRENT_VERSION,
  SET_FULFILLMENT_VERSION,
  SNACK_SET,
  RESET_PLANS_STATE,
  ADD_FOCUS_FULFILLMENT_VALIDATION_REQUEST,
  ADD_FOCUS_FULFILLMENT_VALIDATION_SUCCESS,
  ADD_FOCUS_FULFILLMENT_VALIDATION_FAILURE,
  ADD_PLAN_VALIDATION_REQUEST,
  ADD_PLAN_VALIDATION_SUCCESS,
  ADD_PLAN_VALIDATION_FAILURE,
  SET_AP_YEAR,
  SET_READ_ONLY_MODE,
  SET_CREATING_OUT_OF_TIME_PLAN,
  DELETE_ANNUAL_PLAN_FAILURE,
  DELETE_ANNUAL_PLAN_SUCCESS,
  DELETE_ANNUAL_PLAN_REQUEST,
  UPDATE_ANNUAL_PLAN_REQUEST,
  UPDATE_ANNUAL_PLAN_SUCCESS,
  UPDATE_ANNUAL_PLAN_FAILURE,
  SAVE_PLAN_REQUIREMENT_DECISIONS_REQUEST,
  SAVE_PLAN_REQUIREMENT_DECISIONS_SUCCESS,
  SAVE_PLAN_REQUIREMENT_DECISIONS_FAILURE,
  GET_PLAN_REQUIREMENT_DECISIONS_REQUEST,
  GET_PLAN_REQUIREMENT_DECISIONS_SUCCESS,
  GET_PLAN_REQUIREMENT_DECISIONS_FAILURE,
  SET_SELECTED_HIERARCHICAL_MODEL,
  SET_CURRENT_PLAN_ID,
  REOPEN_PLAN_VERSION_REQUEST,
  REOPEN_PLAN_VERSION_SUCCESS,
  REOPEN_PLAN_VERSION_FAILURE,
  REOPEN_FULFILLMENT_VERSION_REQUEST,
  REOPEN_FULFILLMENT_VERSION_SUCCESS,
  REOPEN_FULFILLMENT_VERSION_FAILURE,
  GET_PLAN_VALIDATION_REQUEST,
  GET_PLAN_VALIDATION_SUCCESS,
  GET_PLAN_VALIDATION_FAILURE,
  GET_FOCUS_FULFILLMENT_VALIDATIONS_REQUEST,
  GET_FOCUS_FULFILLMENT_VALIDATIONS_SUCCESS,
  GET_FOCUS_FULFILLMENT_VALIDATIONS_FAILURE,
  ANULAR_PLAN_VERSION_REQUEST,
  ANULAR_PLAN_VERSION_SUCCESS,
  ANULAR_PLAN_VERSION_FAILURE,
  RETURN_PLAN_TO_DEFINITION_REQUEST,
  RETURN_PLAN_TO_DEFINITION_SUCCESS,
  RETURN_PLAN_TO_DEFINITION_FAILURE,
  GET_USER_ROLES_REQUEST,
  GET_USER_ROLES_SUCCESS,
  GET_USER_ROLES_FAILURE,
  GET_OUT_OF_TIME_REQUEST_STATUS_REQUEST,
  GET_OUT_OF_TIME_REQUEST_STATUS_SUCCESS,
  GET_OUT_OF_TIME_REQUEST_STATUS_FAILURE,
  SUBMIT_OUT_OF_TIME_REQUEST_REQUEST,
  SUBMIT_OUT_OF_TIME_REQUEST_SUCCESS,
  SUBMIT_OUT_OF_TIME_REQUEST_FAILURE,
  PROCESS_OUT_OF_TIME_DECISION_REQUEST,
  PROCESS_OUT_OF_TIME_DECISION_SUCCESS,
  PROCESS_OUT_OF_TIME_DECISION_FAILURE,
  PROCESS_REOPEN_TOKEN_DECISION_REQUEST,
  PROCESS_REOPEN_TOKEN_DECISION_SUCCESS,
  PROCESS_REOPEN_TOKEN_DECISION_FAILURE,
  GET_REQUIREMENTS_REQUEST,
  GET_REQUIREMENTS_SUCCESS,
  GET_REQUIREMENTS_FAILURE,
  GET_FOCUSES_REQUEST,
  GET_FOCUSES_SUCCESS,
  GET_FOCUSES_FAILURE,
  GET_OBJECTIVES_REQUEST,
  GET_OBJECTIVES_SUCCESS,
  GET_OBJECTIVES_FAILURE,
  GET_ACTIVITIES_REQUEST,
  GET_ACTIVITIES_SUCCESS,
  GET_ACTIVITIES_FAILURE,
  GET_CHECKLISTS_REQUEST,
  GET_CHECKLISTS_SUCCESS,
  GET_CHECKLISTS_FAILURE,
  CHECKLIST_RESPONSES_REQUEST,
  CHECKLIST_RESPONSES_SUCCESS,
  CHECKLIST_RESPONSES_FAILURE,
} from './constants';
import {
  PaginatedPlansResponse,
  CreatePlanInput,
  CreateFocusDefinitionApprovalInput,
  CreatePlanDefinitionApprovalInput,
  CreateFocusFulfillmentInput,
  CreatePlanValidationInput,
  DEFAULT_SORT_BY,
  PlanRequirementDecision,
  PlanRequirementDecisionInput,
  AnnualPlanComplianceContext,
  AnnualPlanStep0Context,
  AnnualPlanStep1Context,
  AnnualPlanStep2Context,
  PLAN_STAGES,
  AnnualPlanExportFilters,
} from '@shared/schema';
import {
  PlansState,
  Action,
  ThunkAPI,
  OutOfTimeRequestStatusState,
  OutOfTimeRequestSummary,
} from '../types/state';

const defaultState: PlansState = {
  plans: [],
  filtroOptions: {
    hierarchicalModels: [],
    status: [],
    years: [],
  },
  plansFetchRequestId: 0,
  periods: [],
  scopeName: '',
  enterpriseName: '',
  currentVersion: null,
  currentPlanId: null,
  selectedYear: null,
  selectedHierarchicalModelId: null,
  currentBusinessUnit: null,
  readOnlyMode: false,
  creatingOutOfTimePlan: false,
  activeOutOfTimeRequestId: null,
  userRoles: [],
  loadingUserRoles: false,
  outOfTimeRequestStatus: null,
  loadingOutOfTimeRequestStatus: false,
  submittingOutOfTimeRequest: false,
  processingOutOfTimeDecision: false,
  processingReopenDecision: false,
  currentFulfillmentVersion: null,
  focusFulfillmentValidations: [],
  planRequirementDecisions: [],
  loading: false,
  errorMessage: null,
  planValidation: null,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  },
};

const EMPTY_OUT_OF_TIME_STATUS: OutOfTimeRequestStatusState = {
  pendingRequest: null,
  approvedRequest: null,
};

export const reducer = createReducer(defaultState, {
  [GET_PLANS_REQUEST]: handleGetPlansRequest,
  [GET_PLANS_SUCCESS]: handleGetPlansSuccess,
  [GET_PLANS_FAILURE]: handleGetPlansFailure,
  [EXPORT_ANNUAL_PLANS_CSV_REQUEST]: handleExportAnnualPlansCSVRequest,
  [EXPORT_ANNUAL_PLANS_CSV_SUCCESS]: handleExportAnnualPlansCSVSuccess,
  [EXPORT_ANNUAL_PLANS_CSV_FAILURE]: handleExportAnnualPlansCSVFailure,
  [EXPORT_ANNUAL_PLANS_EXCEL_REQUEST]: handleExportAnnualPlansExcelRequest,
  [EXPORT_ANNUAL_PLANS_EXCEL_SUCCESS]: handleExportAnnualPlansExcelSuccess,
  [EXPORT_ANNUAL_PLANS_EXCEL_FAILURE]: handleExportAnnualPlansExcelFailure,
  [CREATE_ANNUAL_PLAN_REQUEST]: handlecreateAnnualPlanRequest,
  [CREATE_ANNUAL_PLAN_SUCCESS]: handleCreateAnnualPlanSuccess,
  [CREATE_ANNUAL_PLAN_FAILURE]: handleCreateAnnualPlanFailure,
  [ADD_FOCUS_DEFINITION_APPROVAL_REQUEST]: handleAddFocusDefinitionApprovalRequest,
  [ADD_FOCUS_DEFINITION_APPROVAL_SUCCESS]: handleAddFocusDefinitionApprovalSuccess,
  [ADD_FOCUS_DEFINITION_APPROVAL_FAILURE]: handleAddFocusDefinitionApprovalFailure,
  [ADD_PLAN_DEFINITION_APPROVAL_REQUEST]: handleAddPlanDefinitionApprovalRequest,
  [ADD_PLAN_DEFINITION_APPROVAL_SUCCESS]: handleAddPlanDefinitionApprovalSuccess,
  [ADD_PLAN_DEFINITION_APPROVAL_FAILURE]: handleAddPlanDefinitionApprovalFailure,
  [GET_FOCUS_DEFINITION_APPROVALS_REQUEST]: handleGetFocusDefinitionApprovalsRequest,
  [GET_FOCUS_DEFINITION_APPROVALS_SUCCESS]: handleGetFocusDefinitionApprovalsSuccess,
  [GET_FOCUS_DEFINITION_APPROVALS_FAILURE]: handleGetFocusDefinitionApprovalsFailure,
  [GET_PLAN_DEFINITION_APPROVAL_REQUEST]: handleGetPlanDefinitionApprovalRequest,
  [GET_PLAN_DEFINITION_APPROVAL_SUCCESS]: handleGetPlanDefinitionApprovalSuccess,
  [GET_PLAN_DEFINITION_APPROVAL_FAILURE]: handleGetPlanDefinitionApprovalFailure,
  [GET_PLAN_VALIDATION_REQUEST]: handleGetPlanValidationRequest,
  [GET_PLAN_VALIDATION_SUCCESS]: handleGetPlanValidationSuccess,
  [GET_PLAN_VALIDATION_FAILURE]: handleGetPlanValidationFailure,
  [ADD_PLAN_VALIDATION_REQUEST]: handleAddPlanValidationRequest,
  [ADD_PLAN_VALIDATION_SUCCESS]: handleAddPlanValidationSuccess,
  [ADD_PLAN_VALIDATION_FAILURE]: handleAddPlanValidationFailure,
  [SET_CURRENT_VERSION]: handleSetCurrentVersion,
  [SET_FULFILLMENT_VERSION]: handleSetFulfillmentVersion,
  [MARK_PLAN_VERSION_FOR_APPROVAL_REQUEST]: markPlanVersionForApprovalRequest,
  [MARK_PLAN_VERSION_FOR_APPROVAL_SUCCESS]: markPlanVersionForApprovalSuccess,
  [MARK_PLAN_VERSION_FOR_APPROVAL_FAILURE]: markPlanVersionForApprovalerror,
  [MARK_PLAN_FULFILLMENT_VERSION_FOR_APPROVAL_REQUEST]: markFulfillmentVersionForApprovalRequest,
  [MARK_PLAN_FULFILLMENT_VERSION_FOR_APPROVAL_SUCCESS]: markFulfillmentVersionForApprovalSuccess,
  [MARK_PLAN_FULFILLMENT_VERSION_FOR_APPROVAL_FAILURE]: markFulfillmentVersionForApprovalFailure,
  [CREATE_FULFILLMENT_VERSION_REQUEST]: handleCreateFulfillmentVersionRequest,
  [CREATE_FULFILLMENT_VERSION_SUCCESS]: handleCreateFulfillmentVersionSuccess,
  [CREATE_FULFILLMENT_VERSION_FAILURE]: handleCreateFulfillmentVersionFailure,
  [DELETE_ANNUAL_PLAN_FAILURE]: handleDeleteAnnualPlanFailure,
  [DELETE_ANNUAL_PLAN_SUCCESS]: handleDeleteAnnualPlanSuccess,
  [DELETE_ANNUAL_PLAN_REQUEST]: handleDeleteAnnualPlanRequest,
  [UPDATE_ANNUAL_PLAN_REQUEST]: handleUpdateAnnualPlanRequest,
  [UPDATE_ANNUAL_PLAN_SUCCESS]: handleUpdateAnnualPlanSuccess,
  [UPDATE_ANNUAL_PLAN_FAILURE]: handleUpdateAnnualPlanFailure,
  [SAVE_PLAN_REQUIREMENT_DECISIONS_REQUEST]: handleSavePlanRequirementDecisionsRequest,
  [SAVE_PLAN_REQUIREMENT_DECISIONS_SUCCESS]: handleSavePlanRequirementDecisionsSuccess,
  [SAVE_PLAN_REQUIREMENT_DECISIONS_FAILURE]: handleSavePlanRequirementDecisionsFailure,
  [GET_PLAN_REQUIREMENT_DECISIONS_REQUEST]: handleGetPlanRequirementDecisionsRequest,
  [GET_PLAN_REQUIREMENT_DECISIONS_SUCCESS]: handleGetPlanRequirementDecisionsSuccess,
  [GET_PLAN_REQUIREMENT_DECISIONS_FAILURE]: handleGetPlanRequirementDecisionsFailure,
  [SET_READ_ONLY_MODE]: handleSetReadOnlyMode,
  [SET_CREATING_OUT_OF_TIME_PLAN]: handleSetCreatingOutOfTimePlan,
  [SET_AP_YEAR]: handleSetApYear,
  [SET_CURRENT_BUSINESS_UNIT]: handleSetCurrentBusinessUnit,
  [SET_SELECTED_HIERARCHICAL_MODEL]: handleSetSelectedHierarchicalModel,
  [SET_CURRENT_PLAN_ID]: handleSetCurrentPlanId,
  [GET_USER_ROLES_REQUEST]: handleGetUserRolesRequest,
  [GET_USER_ROLES_SUCCESS]: handleGetUserRolesSuccess,
  [GET_USER_ROLES_FAILURE]: handleGetUserRolesFailure,
  [GET_OUT_OF_TIME_REQUEST_STATUS_REQUEST]: handleGetOutOfTimeStatusRequest,
  [GET_OUT_OF_TIME_REQUEST_STATUS_SUCCESS]: handleGetOutOfTimeStatusSuccess,
  [GET_OUT_OF_TIME_REQUEST_STATUS_FAILURE]: handleGetOutOfTimeStatusFailure,
  [SUBMIT_OUT_OF_TIME_REQUEST_REQUEST]: handleSubmitOutOfTimeRequestRequest,
  [SUBMIT_OUT_OF_TIME_REQUEST_SUCCESS]: handleSubmitOutOfTimeRequestSuccess,
  [SUBMIT_OUT_OF_TIME_REQUEST_FAILURE]: handleSubmitOutOfTimeRequestFailure,
  [PROCESS_OUT_OF_TIME_DECISION_REQUEST]: handleProcessOutOfTimeDecisionRequest,
  [PROCESS_OUT_OF_TIME_DECISION_SUCCESS]: handleProcessOutOfTimeDecisionSuccess,
  [PROCESS_OUT_OF_TIME_DECISION_FAILURE]: handleProcessOutOfTimeDecisionFailure,
  [PROCESS_REOPEN_TOKEN_DECISION_REQUEST]: handleProcessReopenDecisionRequest,
  [PROCESS_REOPEN_TOKEN_DECISION_SUCCESS]: handleProcessReopenDecisionSuccess,
  [PROCESS_REOPEN_TOKEN_DECISION_FAILURE]: handleProcessReopenDecisionFailure,
  [RESET_PLANS_STATE]: () => defaultState,
  [GET_FOCUS_FULFILLMENT_VALIDATIONS_REQUEST]: handleGetFocusFulfillmentValidationsRequest,
  [GET_FOCUS_FULFILLMENT_VALIDATIONS_SUCCESS]: handleGetFocusFulfillmentValidationsSuccess,
  [GET_FOCUS_FULFILLMENT_VALIDATIONS_FAILURE]: handleGetFocusFulfillmentValidationsFailure,
  [ANULAR_PLAN_VERSION_REQUEST]: handleAnularPlanVersionRequest,
  [ANULAR_PLAN_VERSION_SUCCESS]: handleAnularPlanVersionSuccess,
  [ANULAR_PLAN_VERSION_FAILURE]: handleAnularPlanVersionFailure,
  [RETURN_PLAN_TO_DEFINITION_REQUEST]: handleReturnPlanToDefinitionRequest,
  [RETURN_PLAN_TO_DEFINITION_SUCCESS]: handleReturnPlanToDefinitionSuccess,
  [RETURN_PLAN_TO_DEFINITION_FAILURE]: handleReturnPlanToDefinitionFailure,
});

function handleAnularPlanVersionRequest(state: PlansState): PlansState {
  return {
    ...state,
    loading: true,
  };
}
function handleAnularPlanVersionSuccess(state: PlansState, action: Action<unknown>): PlansState {
  return {
    ...state,
    loading: false,
    errorMessage: null,
  };
}

function handleAnularPlanVersionFailure(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { error: unknown } | undefined;
  return {
    ...state,
    loading: false,
    errorMessage: payload?.error
      ? String(payload.error)
      : 'An error occurred anularing plan version',
  };
}

function handleReturnPlanToDefinitionRequest(state: PlansState): PlansState {
  return {
    ...state,
    loading: true,
  };
}

function handleReturnPlanToDefinitionSuccess(
  state: PlansState,
  _action: Action<unknown>,
): PlansState {
  return {
    ...state,
    loading: false,
    errorMessage: null,
  };
}

function handleReturnPlanToDefinitionFailure(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  const payload = action.payload as { error: unknown } | undefined;
  return {
    ...state,
    loading: false,
    errorMessage: payload?.error
      ? String(payload.error)
      : 'An error occurred returning the plan to definition',
  };
}

function handleGetFocusFulfillmentValidationsRequest(state: PlansState): PlansState {
  return {
    ...state,
    loading: true,
  };
}

function handleGetFocusFulfillmentValidationsSuccess(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  return {
    ...state,
    loading: false,
    focusFulfillmentValidations: action.payload as any[],
    errorMessage: null,
  };
}

function handleGetFocusFulfillmentValidationsFailure(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  const payload = action.payload as { error: unknown } | undefined;
  return {
    ...state,
    loading: false,
    errorMessage: payload?.error
      ? String(payload.error)
      : 'An error occurred fetching Focus Fulfillment Validations',
    focusFulfillmentValidations: [],
  };
}

function handleGetPlansRequest(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { requestId?: number } | undefined;
  return {
    ...state,
    loading: true,
    plansFetchRequestId: payload?.requestId ?? state.plansFetchRequestId,
  };
}

function handleGetPlansSuccess(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as
    | { requestId: number; response: PaginatedPlansResponse }
    | PaginatedPlansResponse;
  const requestId =
    'requestId' in (payload as object)
      ? (payload as { requestId: number }).requestId
      : state.plansFetchRequestId;
  if (requestId !== state.plansFetchRequestId) {
    return state;
  }
  const response =
    'response' in (payload as object)
      ? (payload as { requestId: number; response: PaginatedPlansResponse }).response
      : (payload as PaginatedPlansResponse);

  return {
    ...state,
    loading: false,
    plans: response.data || [],
    filtroOptions: response.filterOptions || {
      hierarchicalModelIds: [],
      status: [],
      years: [],
    },
    periods: response.periods || [],
    scopeName: response.scopeName || '',
    enterpriseName: response.enterpriseName || '',
    pagination: response.pagination,
    errorMessage: null,
  };
}

function markPlanVersionForApprovalerror(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { error: unknown } | undefined;
  return {
    ...state,
    loading: false,
    errorMessage: payload?.error
      ? String(payload.error)
      : 'An error occurred marking version for approval',
  };
}

function markPlanVersionForApprovalSuccess(state: PlansState, action: Action<unknown>): PlansState {
  return {
    ...state,
    loading: false,
    errorMessage: null,
  };
}

function markPlanVersionForApprovalRequest(state: PlansState): PlansState {
  return {
    ...state,
    loading: true,
  };
}

function markFulfillmentVersionForApprovalRequest(state: PlansState): PlansState {
  return {
    ...state,
    loading: true,
  };
}

function markFulfillmentVersionForApprovalSuccess(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  return {
    ...state,
    loading: false,
    errorMessage: null,
  };
}

function markFulfillmentVersionForApprovalFailure(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  const payload = action.payload as { error: unknown } | undefined;
  return {
    ...state,
    loading: false,
    errorMessage: payload?.error
      ? String(payload.error)
      : 'An error occurred marking fulfillment version for approval',
  };
}

function handleGetPlansFailure(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { error: unknown; requestId?: number } | undefined;
  if (payload?.requestId && payload.requestId !== state.plansFetchRequestId) {
    return state;
  }
  return {
    ...state,
    loading: false,
    errorMessage: payload?.error ? String(payload.error) : 'An error occurred',
  };
}

function handleExportAnnualPlansCSVRequest(state: PlansState): PlansState {
  return {
    ...state,
    loading: true,
  };
}

function handleExportAnnualPlansCSVSuccess(
  state: PlansState,
  _action: Action<unknown>,
): PlansState {
  return {
    ...state,
    loading: false,
    errorMessage: null,
  };
}

function handleExportAnnualPlansCSVFailure(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { error: unknown } | undefined;
  return {
    ...state,
    loading: false,
    errorMessage: payload?.error ? String(payload.error) : 'An error occurred exporting CSV',
  };
}

function handleExportAnnualPlansExcelRequest(state: PlansState): PlansState {
  return {
    ...state,
    loading: true,
  };
}

function handleExportAnnualPlansExcelSuccess(
  state: PlansState,
  _action: Action<unknown>,
): PlansState {
  return {
    ...state,
    loading: false,
    errorMessage: null,
  };
}

function handleExportAnnualPlansExcelFailure(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  const payload = action.payload as { error: unknown } | undefined;
  return {
    ...state,
    loading: false,
    errorMessage: payload?.error ? String(payload.error) : 'An error occurred exporting Excel',
  };
}

function handlecreateAnnualPlanRequest(state: PlansState): PlansState {
  return {
    ...state,
    loading: true,
  };
}

function handleCreateAnnualPlanSuccess(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { plan: any; version: any };

  return {
    ...state,
    loading: false,
    plans: [payload.plan, ...state.plans],
    errorMessage: null,
  };
}

function handleCreateAnnualPlanFailure(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { error: unknown } | undefined;
  return {
    ...state,
    loading: false,
    errorMessage: payload?.error
      ? String(payload.error)
      : 'An error occurred creating the annual plan',
  };
}

function handleAddFocusDefinitionApprovalRequest(state: PlansState): PlansState {
  return {
    ...state,
    loading: true,
  };
}

function handleAddFocusDefinitionApprovalSuccess(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  return {
    ...state,
    loading: false,
    errorMessage: null,
  };
}

function handleAddFocusDefinitionApprovalFailure(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  const payload = action.payload as { error: unknown } | undefined;
  return {
    ...state,
    loading: false,
    errorMessage: payload?.error
      ? String(payload.error)
      : 'An error occurred adding Focus Definition Approval',
  };
}

function handleCreateFulfillmentVersionRequest(state: PlansState): PlansState {
  return {
    ...state,
    loading: true,
  };
}

function handleCreateFulfillmentVersionSuccess(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  const payload = action.payload as {
    APFulfillmentsVersionId?: number;
    result?: { APFulfillmentsVersionId?: number };
  };
  const fulfillmentVersionId =
    payload?.APFulfillmentsVersionId ?? payload?.result?.APFulfillmentsVersionId ?? null;
  return {
    ...state,
    loading: false,
    errorMessage: null,
    currentFulfillmentVersion: fulfillmentVersionId,
  };
}

function handleCreateFulfillmentVersionFailure(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  const payload = action.payload as { error: unknown } | undefined;
  return {
    ...state,
    loading: false,
    errorMessage: payload?.error
      ? String(payload.error)
      : t('apiFeedback.plans.createFulfillmentVersionError'),
  };
}

function handleAddPlanDefinitionApprovalRequest(state: PlansState): PlansState {
  return {
    ...state,
    loading: true,
  };
}

function handleAddPlanDefinitionApprovalSuccess(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  return {
    ...state,
    loading: false,
    errorMessage: null,
  };
}

function handleAddPlanDefinitionApprovalFailure(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  const payload = action.payload as { error: unknown } | undefined;
  return {
    ...state,
    loading: false,
    errorMessage: payload?.error
      ? String(payload.error)
      : t('apiFeedback.plans.addPlanDefinitionApprovalError'),
  };
}

function handleGetFocusDefinitionApprovalsRequest(state: PlansState): PlansState {
  return {
    ...state,
    loading: true,
  };
}

function handleGetFocusDefinitionApprovalsSuccess(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  return {
    ...state,
    loading: false,
    errorMessage: null,
  };
}

function handleGetFocusDefinitionApprovalsFailure(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  const payload = action.payload as { error: unknown } | undefined;
  return {
    ...state,
    loading: false,
    errorMessage: payload?.error ? String(payload.error) : t('apiFeedback.plans.genericError'),
  };
}

function handleGetPlanDefinitionApprovalRequest(state: PlansState): PlansState {
  return {
    ...state,
    loading: true,
  };
}

function handleGetPlanDefinitionApprovalSuccess(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  return {
    ...state,
    loading: false,
    errorMessage: null,
  };
}

function handleGetPlanDefinitionApprovalFailure(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  const payload = action.payload as { error: unknown } | undefined;
  return {
    ...state,
    loading: false,
    errorMessage: payload?.error ? String(payload.error) : t('apiFeedback.plans.genericError'),
  };
}

function handleGetPlanValidationRequest(state: PlansState): PlansState {
  return { ...state, loading: true };
}
function handleGetPlanValidationSuccess(state: PlansState, action: Action<unknown>): PlansState {
  return { ...state, loading: false, planValidation: action.payload as any };
}
function handleGetPlanValidationFailure(state: PlansState, action: Action<unknown>): PlansState {
  return { ...state, loading: false };
}
function handleAddPlanValidationRequest(state: PlansState): PlansState {
  return { ...state, loading: true };
}
function handleAddPlanValidationSuccess(state: PlansState, action: Action<unknown>): PlansState {
  return { ...state, loading: false, planValidation: action.payload as any };
}
function handleAddPlanValidationFailure(state: PlansState, action: Action<unknown>): PlansState {
  return { ...state, loading: false };
}

function handleSetCurrentVersion(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { version: number | null };
  return {
    ...state,
    currentVersion: payload.version,
  };
}

function handleSetApYear(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { year: number | null };
  return {
    ...state,
    selectedYear: payload.year,
  };
}

function handleSetCurrentBusinessUnit(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { currentBusinessUnit: string | null };
  return { ...state, currentBusinessUnit: payload.currentBusinessUnit };
}

function handleSetSelectedHierarchicalModel(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  const payload = action.payload as { hierarchicalModelId: number | null };
  return { ...state, selectedHierarchicalModelId: payload.hierarchicalModelId };
}

function handleSetCurrentPlanId(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { planId: number | null };
  return { ...state, currentPlanId: payload.planId };
}

function handleSetFulfillmentVersion(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { version: number | null };
  return {
    ...state,
    currentFulfillmentVersion: payload.version,
  };
}

function handleSetReadOnlyMode(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { readOnly: boolean };
  return {
    ...state,
    readOnlyMode: payload.readOnly,
  };
}

function handleSetCreatingOutOfTimePlan(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as {
    creatingOutOfTimePlan: boolean;
    requestId?: number | null;
  };
  return {
    ...state,
    creatingOutOfTimePlan: payload.creatingOutOfTimePlan,
  };
}

function handleGetUserRolesRequest(state: PlansState): PlansState {
  return {
    ...state,
    loadingUserRoles: true,
  };
}

function handleGetUserRolesSuccess(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { roles?: string[] } | undefined;
  return {
    ...state,
    loadingUserRoles: false,
    userRoles: payload?.roles ?? [],
  };
}

function handleGetUserRolesFailure(state: PlansState): PlansState {
  return {
    ...state,
    loadingUserRoles: false,
  };
}

function handleGetOutOfTimeStatusRequest(state: PlansState): PlansState {
  return {
    ...state,
    loadingOutOfTimeRequestStatus: true,
  };
}

function handleGetOutOfTimeStatusSuccess(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { status: OutOfTimeRequestStatusState | null } | undefined;
  return {
    ...state,
    loadingOutOfTimeRequestStatus: false,
    outOfTimeRequestStatus: payload?.status ?? { pendingRequest: null, approvedRequest: null },
    activeOutOfTimeRequestId:
      payload?.status?.approvedRequest?.status === 'APPROVED' &&
      !payload?.status?.approvedRequest?.usedAt
        ? (payload?.status?.approvedRequest?.id ?? null)
        : null,
  };
}

function handleGetOutOfTimeStatusFailure(state: PlansState): PlansState {
  return {
    ...state,
    loadingOutOfTimeRequestStatus: false,
  };
}

function handleSubmitOutOfTimeRequestRequest(state: PlansState): PlansState {
  return {
    ...state,
    submittingOutOfTimeRequest: true,
  };
}

function handleSubmitOutOfTimeRequestSuccess(state: PlansState): PlansState {
  return {
    ...state,
    submittingOutOfTimeRequest: false,
  };
}

function handleSubmitOutOfTimeRequestFailure(state: PlansState): PlansState {
  return {
    ...state,
    submittingOutOfTimeRequest: false,
  };
}

function handleProcessOutOfTimeDecisionRequest(state: PlansState): PlansState {
  return {
    ...state,
    processingOutOfTimeDecision: true,
  };
}

function handleProcessOutOfTimeDecisionSuccess(state: PlansState): PlansState {
  return {
    ...state,
    processingOutOfTimeDecision: false,
  };
}

function handleProcessOutOfTimeDecisionFailure(state: PlansState): PlansState {
  return {
    ...state,
    processingOutOfTimeDecision: false,
  };
}

function handleProcessReopenDecisionRequest(state: PlansState): PlansState {
  return {
    ...state,
    processingReopenDecision: true,
  };
}

function handleProcessReopenDecisionSuccess(state: PlansState): PlansState {
  return {
    ...state,
    processingReopenDecision: false,
  };
}

function handleProcessReopenDecisionFailure(state: PlansState): PlansState {
  return {
    ...state,
    processingReopenDecision: false,
  };
}

function handleDeleteAnnualPlanRequest(state: PlansState): PlansState {
  return {
    ...state,
    loading: true,
    errorMessage: null,
  };
}

function handleDeleteAnnualPlanSuccess(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { id: number };
  return {
    ...state,
    loading: false,
    plans: state.plans.filter((plan) => plan.APId !== payload.id),
    errorMessage: null,
  };
}

function handleDeleteAnnualPlanFailure(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { error: unknown } | undefined;
  return {
    ...state,
    loading: false,
    errorMessage: payload?.error ? String(payload.error) : t('apiFeedback.plans.deleteError'),
  };
}

function handleUpdateAnnualPlanRequest(state: PlansState): PlansState {
  return { ...state, loading: true, errorMessage: null };
}

function handleUpdateAnnualPlanSuccess(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { plan: any };
  return {
    ...state,
    loading: false,
    plans: state.plans.map((p) => (p.APId === payload.plan.APId ? { ...p, ...payload.plan } : p)),
    selectedYear: payload.plan.Year ?? state.selectedYear,
    selectedHierarchicalModelId:
      payload.plan.HierarchicalModelId ?? state.selectedHierarchicalModelId,
    errorMessage: null,
  };
}

function handleUpdateAnnualPlanFailure(state: PlansState, action: Action<unknown>): PlansState {
  const payload = action.payload as { error: unknown } | undefined;
  return {
    ...state,
    loading: false,
    errorMessage: payload?.error ? String(payload.error) : t('apiFeedback.plans.updateError'),
  };
}

function handleSavePlanRequirementDecisionsRequest(state: PlansState): PlansState {
  return {
    ...state,
    loading: true,
  };
}

function handleSavePlanRequirementDecisionsSuccess(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  const payload = action.payload as { decisions: PlanRequirementDecision[] } | undefined;
  return {
    ...state,
    loading: false,
    planRequirementDecisions: payload?.decisions ?? state.planRequirementDecisions,
    errorMessage: null,
  };
}

function handleSavePlanRequirementDecisionsFailure(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  const payload = action.payload as { error?: unknown } | undefined;
  return {
    ...state,
    loading: false,
    errorMessage:
      payload?.error?.toString() ?? t('apiFeedback.plans.requirementsSaveError' as const),
  };
}

function handleGetPlanRequirementDecisionsRequest(state: PlansState): PlansState {
  return {
    ...state,
  };
}

function handleGetPlanRequirementDecisionsSuccess(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  const payload = action.payload as { decisions: PlanRequirementDecision[] } | undefined;
  return {
    ...state,
    planRequirementDecisions: payload?.decisions ?? [],
    errorMessage: null,
  };
}

function handleGetPlanRequirementDecisionsFailure(
  state: PlansState,
  action: Action<unknown>,
): PlansState {
  const payload = action.payload as { error?: unknown } | undefined;
  return {
    ...state,
    errorMessage:
      payload?.error?.toString() ?? t('apiFeedback.plans.requirementsSaveError' as const),
  };
}

export function setReadOnlyMode(readOnly: boolean) {
  return (dispatch: ThunkAPI['dispatch']) => {
    dispatch({ type: SET_READ_ONLY_MODE, payload: { readOnly } });
  };
}

export function setCreatingOutOfTimePlan(
  creatingOutOfTimePlan: boolean,
  requestId?: number | null,
) {
  return (dispatch: ThunkAPI['dispatch']) => {
    dispatch({
      type: SET_CREATING_OUT_OF_TIME_PLAN,
      payload: { creatingOutOfTimePlan, requestId: requestId ?? null },
    });
  };
}

export function createAnnualPlan(data: CreatePlanInput) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: CREATE_ANNUAL_PLAN_REQUEST });
    try {
      const result = await dataSource.createAnnualPlan(data);
      dispatch({ type: CREATE_ANNUAL_PLAN_SUCCESS, payload: result });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: { open: true, message: t('apiFeedback.plans.createSuccess'), severity: 'success' },
        },
      });
      if (data.Status === PLAN_STAGES.DEFINITION_OUT_OF_TIME) {
        await (dispatch as unknown as (arg: unknown) => Promise<unknown>)(
          fetchOutOfTimeRequestStatus(),
        );
      }
      return result;
    } catch (error) {
      console.error({ error });
      dispatch({ type: CREATE_ANNUAL_PLAN_FAILURE, payload: error });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: { open: true, message: t('apiFeedback.plans.createError'), severity: 'error' },
        },
      });
      throw error;
    }
  };
}

export function setSelectedHierarchicalModel(hierarchicalModelId: number | null) {
  return (dispatch: ThunkAPI['dispatch']) => {
    dispatch({ type: SET_SELECTED_HIERARCHICAL_MODEL, payload: { hierarchicalModelId } });
  };
}

export function setCurrentPlanId(planId: number | null) {
  return (dispatch: ThunkAPI['dispatch']) => {
    dispatch({ type: SET_CURRENT_PLAN_ID, payload: { planId } });
  };
}

export function fetchCurrentUserRoles() {
  return async (
    dispatch: ThunkAPI['dispatch'],
    _getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: GET_USER_ROLES_REQUEST });
    try {
      const roles = await dataSource.getCurrentUserRoles();
      dispatch({ type: GET_USER_ROLES_SUCCESS, payload: { roles } });
      return roles;
    } catch (error) {
      console.error('[plans][roles] error fetching user roles', error);
      dispatch({ type: GET_USER_ROLES_FAILURE, payload: { error } });
      return [];
    }
  };
}

export function fetchOutOfTimeRequestStatus() {
  return async (
    dispatch: ThunkAPI['dispatch'],
    _getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: GET_OUT_OF_TIME_REQUEST_STATUS_REQUEST });
    try {
      const raw = await dataSource.getOutOfTimePlanRequestStatus();
      const status = normalizeOutOfTimeStatusResponse(raw);
      dispatch({ type: GET_OUT_OF_TIME_REQUEST_STATUS_SUCCESS, payload: { status } });
      return status;
    } catch (error) {
      console.error('[plans][outOfTime] error fetching status', error);
      dispatch({ type: GET_OUT_OF_TIME_REQUEST_STATUS_FAILURE, payload: { error } });
      return EMPTY_OUT_OF_TIME_STATUS;
    }
  };
}

export function submitOutOfTimeRequest(reason: string) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    _getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: SUBMIT_OUT_OF_TIME_REQUEST_REQUEST });
    try {
      await dataSource.createOutOfTimePlanRequest(reason);
      dispatch({ type: SUBMIT_OUT_OF_TIME_REQUEST_SUCCESS });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('annualPlanning.outOfTimeRequestSuccess'),
            severity: 'success',
          },
        },
      });
      await (dispatch as unknown as (arg: unknown) => Promise<unknown>)(
        fetchOutOfTimeRequestStatus(),
      );
    } catch (error) {
      console.error('[plans][outOfTime] error creating request', error);
      dispatch({ type: SUBMIT_OUT_OF_TIME_REQUEST_FAILURE, payload: { error } });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('annualPlanning.outOfTimeRequestError'),
            severity: 'error',
          },
        },
      });
      throw error;
    }
  };
}

export function processOutOfTimeRequestDecision(params: {
  requestId: number;
  decision: 'accept' | 'reject';
  token: string;
  rejectionReason?: string;
}) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    _getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: PROCESS_OUT_OF_TIME_DECISION_REQUEST });
    try {
      await dataSource.decideOutOfTimePlanRequest(
        params.requestId,
        params.decision,
        params.token,
        params.rejectionReason,
      );
      dispatch({ type: PROCESS_OUT_OF_TIME_DECISION_SUCCESS });
    } catch (error) {
      console.error('[plans][outOfTime] error processing decision', error);
      dispatch({ type: PROCESS_OUT_OF_TIME_DECISION_FAILURE, payload: { error } });
      throw error;
    }
  };
}

function normalizeOutOfTimeStatusResponse(raw: unknown): OutOfTimeRequestStatusState {
  if (!raw || typeof raw !== 'object') return EMPTY_OUT_OF_TIME_STATUS;
  const candidate = raw as Record<string, unknown>;
  return {
    pendingRequest: candidate['pendingRequest']
      ? normalizeOutOfTimeRequestSummary(candidate['pendingRequest'])
      : null,
    approvedRequest: candidate['approvedRequest']
      ? normalizeOutOfTimeRequestSummary(candidate['approvedRequest'])
      : null,
  };
}

function normalizeOutOfTimeRequestSummary(raw: unknown): OutOfTimeRequestSummary {
  const record = (raw && typeof raw === 'object' ? (raw as Record<string, unknown>) : {}) as Record<
    string,
    unknown
  >;
  return {
    id: Number(record['id'] ?? record['APOutOfTimePlanRequestId'] ?? 0),
    reason: String(record['reason'] ?? record['Reason'] ?? ''),
    status: String(record['status'] ?? record['Status'] ?? ''),
    createdAt: (record['createdAt'] ?? record['Created_at'] ?? null) as string | null,
    approvedAt: (record['approvedAt'] ?? record['ApprovedAt'] ?? null) as string | null,
    usedAt: (record['usedAt'] ?? record['UsedAt'] ?? null) as string | null,
  };
}

export function updateAnnualPlan(
  planId: number,
  data: { Year?: number; HierarchicalModelId?: number },
) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: UPDATE_ANNUAL_PLAN_REQUEST });
    try {
      const plan = await dataSource.updateAnnualPlan(planId, data);
      dispatch({ type: UPDATE_ANNUAL_PLAN_SUCCESS, payload: { plan } });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: { open: true, message: t('apiFeedback.plans.updateSuccess'), severity: 'success' },
        },
      });
      return plan;
    } catch (error) {
      dispatch({ type: UPDATE_ANNUAL_PLAN_FAILURE, payload: { error } });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: { open: true, message: t('apiFeedback.plans.updateError'), severity: 'error' },
        },
      });
    }
  };
}

export function savePlanRequirementDecisions(
  planId: number,
  decisions: PlanRequirementDecisionInput[],
) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    _getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: SAVE_PLAN_REQUIREMENT_DECISIONS_REQUEST });
    try {
      await dataSource.savePlanRequirementDecisions(planId, decisions);
      dispatch({
        type: SAVE_PLAN_REQUIREMENT_DECISIONS_SUCCESS,
        payload: { decisions },
      });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.requirementsSaveSuccess'),
            severity: 'success',
          },
        },
      });
    } catch (error) {
      console.error('Error saving plan requirement decisions', error);
      dispatch({ type: SAVE_PLAN_REQUIREMENT_DECISIONS_FAILURE, payload: { error } });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.requirementsSaveError'),
            severity: 'error',
          },
        },
      });
      throw error;
    }
  };
}

export function fetchPlanRequirementDecisions(planId: number) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    _getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ): Promise<PlanRequirementDecision[]> => {
    try {
      dispatch({ type: GET_PLAN_REQUIREMENT_DECISIONS_REQUEST });
      const decisions = await dataSource.getPlanRequirementDecisions(planId);
      dispatch({
        type: GET_PLAN_REQUIREMENT_DECISIONS_SUCCESS,
        payload: { decisions },
      });
      return decisions;
    } catch (error) {
      console.error('Error fetching plan requirement decisions', error);
      dispatch({ type: GET_PLAN_REQUIREMENT_DECISIONS_FAILURE, payload: { error } });
      return [];
    }
  };
}

export function fetchAnnualPlanStep0Context(params: {
  planId?: number;
  versionId?: number;
  year?: number;
}) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    _getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ): Promise<AnnualPlanStep0Context | null> => {
    try {
      dispatch({ type: GET_REQUIREMENTS_REQUEST });
      if (params.planId) {
        dispatch({ type: GET_PLAN_REQUIREMENT_DECISIONS_REQUEST });
      }
      const context = await dataSource.getAnnualPlanStep0Context(params);
      dispatch({ type: GET_REQUIREMENTS_SUCCESS, payload: { requirements: context.requirements } });
      dispatch({
        type: GET_PLAN_REQUIREMENT_DECISIONS_SUCCESS,
        payload: { decisions: context.planRequirementDecisions },
      });
      return context;
    } catch (error) {
      console.error('Error fetching annual plan step 0 context', error);
      const fallbackMessage = t('apiFeedback.requirements.fetchFailure');
      const errorMessage =
        error instanceof Error && error.message ? error.message : fallbackMessage;
      dispatch({ type: GET_REQUIREMENTS_FAILURE, payload: { errorMessage } });
      dispatch({ type: GET_PLAN_REQUIREMENT_DECISIONS_FAILURE, payload: { error } });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: errorMessage,
            severity: 'error',
          },
        },
      });
      return null;
    }
  };
}

export function fetchAnnualPlanStep1Context(versionId: number) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    _getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ): Promise<AnnualPlanStep1Context | null> => {
    try {
      dispatch({ type: GET_FOCUSES_REQUEST });
      dispatch({ type: GET_OBJECTIVES_REQUEST });
      const context = await dataSource.getAnnualPlanStep1Context(versionId);
      dispatch({ type: GET_FOCUSES_SUCCESS, payload: { focuses: context.focuses } });
      dispatch({ type: GET_OBJECTIVES_SUCCESS, payload: { objectives: context.objectives } });
      return context;
    } catch (error) {
      console.error('Error fetching annual plan step 1 context', error);
      dispatch({ type: GET_FOCUSES_FAILURE });
      dispatch({
        type: GET_OBJECTIVES_FAILURE,
        payload: { errorMessage: t('apiFeedback.objectives.fetchError') },
      });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.objectives.fetchError'),
            severity: 'error',
          },
        },
      });
      return null;
    }
  };
}

export function fetchAnnualPlanStep2Context(
  versionId: number,
  params?: { planId?: number; year?: number },
) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    _getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ): Promise<AnnualPlanStep2Context | null> => {
    try {
      dispatch({ type: GET_FOCUSES_REQUEST });
      dispatch({ type: GET_OBJECTIVES_REQUEST });
      dispatch({ type: GET_ACTIVITIES_REQUEST });
      dispatch({ type: GET_REQUIREMENTS_REQUEST });
      if (params?.planId) {
        dispatch({ type: GET_PLAN_REQUIREMENT_DECISIONS_REQUEST });
      }
      const context = await dataSource.getAnnualPlanStep2Context(versionId, params);
      dispatch({ type: GET_FOCUSES_SUCCESS, payload: { focuses: context.focuses } });
      dispatch({ type: GET_OBJECTIVES_SUCCESS, payload: { objectives: context.objectives } });
      dispatch({ type: GET_ACTIVITIES_SUCCESS, payload: { activities: context.activities } });
      dispatch({ type: GET_REQUIREMENTS_SUCCESS, payload: { requirements: context.requirements } });
      dispatch({
        type: GET_PLAN_REQUIREMENT_DECISIONS_SUCCESS,
        payload: { decisions: context.planRequirementDecisions },
      });
      return context;
    } catch (error) {
      console.error('Error fetching annual plan step 2 context', error);
      dispatch({ type: GET_FOCUSES_FAILURE });
      dispatch({
        type: GET_OBJECTIVES_FAILURE,
        payload: { errorMessage: t('apiFeedback.objectives.fetchError') },
      });
      dispatch({
        type: GET_ACTIVITIES_FAILURE,
        payload: { errorMessage: t('apiFeedback.activities.fetchError') },
      });
      dispatch({
        type: GET_REQUIREMENTS_FAILURE,
        payload: { errorMessage: t('apiFeedback.requirements.fetchFailure') },
      });
      dispatch({ type: GET_PLAN_REQUIREMENT_DECISIONS_FAILURE, payload: { error } });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.activities.fetchError'),
            severity: 'error',
          },
        },
      });
      return null;
    }
  };
}

export function fetchAnnualPlanComplianceContext(
  versionId: number | null | undefined,
  fulfillmentVersionId: number,
) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    _getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ): Promise<AnnualPlanComplianceContext | null> => {
    try {
      dispatch({ type: GET_FOCUSES_REQUEST });
      dispatch({ type: GET_OBJECTIVES_REQUEST });
      dispatch({ type: GET_ACTIVITIES_REQUEST });
      dispatch({ type: GET_REQUIREMENTS_REQUEST });
      dispatch({ type: GET_CHECKLISTS_REQUEST });
      dispatch({ type: CHECKLIST_RESPONSES_REQUEST, payload: { responses: [] } });
      const context = await dataSource.getAnnualPlanComplianceContext(fulfillmentVersionId, {
        ...(versionId ? { versionId } : {}),
      });
      dispatch({ type: GET_FOCUSES_SUCCESS, payload: { focuses: context.focuses } });
      dispatch({ type: GET_OBJECTIVES_SUCCESS, payload: { objectives: context.objectives } });
      dispatch({ type: GET_ACTIVITIES_SUCCESS, payload: { activities: context.activities } });
      dispatch({ type: GET_REQUIREMENTS_SUCCESS, payload: { requirements: context.requirements } });
      dispatch({ type: GET_CHECKLISTS_SUCCESS, payload: { checklists: context.checklists } });
      dispatch({
        type: CHECKLIST_RESPONSES_SUCCESS,
        payload: { responses: context.checklistResponses },
      });
      return context;
    } catch (error) {
      console.error('Error fetching annual plan compliance context', error);
      dispatch({ type: GET_FOCUSES_FAILURE });
      dispatch({
        type: GET_OBJECTIVES_FAILURE,
        payload: { errorMessage: t('apiFeedback.objectives.fetchError') },
      });
      dispatch({
        type: GET_ACTIVITIES_FAILURE,
        payload: { errorMessage: t('apiFeedback.activities.fetchError') },
      });
      dispatch({
        type: GET_REQUIREMENTS_FAILURE,
        payload: { errorMessage: t('apiFeedback.requirements.fetchFailure') },
      });
      dispatch({
        type: GET_CHECKLISTS_FAILURE,
        payload: { errorMessage: t('apiFeedback.checklists.fetchError') },
      });
      dispatch({ type: CHECKLIST_RESPONSES_FAILURE, payload: { responses: [] } });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.checklists.fetchError'),
            severity: 'error',
          },
        },
      });
      return null;
    }
  };
}

export function markFulfillmentVersionForApproval(fulfillmentVersionId: number) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: MARK_PLAN_FULFILLMENT_VERSION_FOR_APPROVAL_REQUEST });
    try {
      await dataSource.markFulfillmentVersionForApproval(fulfillmentVersionId);
      dispatch({ type: MARK_PLAN_FULFILLMENT_VERSION_FOR_APPROVAL_SUCCESS });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.markFulfillmentVersionApprovalSuccess'),
            severity: 'success',
          },
        },
      });
    } catch (error) {
      console.error({ error });
      dispatch({ type: MARK_PLAN_FULFILLMENT_VERSION_FOR_APPROVAL_FAILURE, payload: error });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.markFulfillmentVersionApprovalError'),
            severity: 'error',
          },
        },
      });
      throw error;
    }
  };
}

export function markPlanVersionForApproval(versionId: number) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: MARK_PLAN_VERSION_FOR_APPROVAL_REQUEST });
    try {
      await dataSource.markPlanVersionForApproval(versionId);
      dispatch({ type: MARK_PLAN_VERSION_FOR_APPROVAL_SUCCESS });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.markVersionApprovalSuccess'),
            severity: 'success',
          },
        },
      });
    } catch (error) {
      console.error({ error });
      dispatch({ type: MARK_PLAN_VERSION_FOR_APPROVAL_FAILURE, payload: error });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.markVersionApprovalError'),
            severity: 'error',
          },
        },
      });
      throw error;
    }
  };
}

export function reopenPlanVersion(versionId: number, reason = '') {
  return async (
    dispatch: ThunkAPI['dispatch'],
    getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: REOPEN_PLAN_VERSION_REQUEST });
    try {
      const result = await dataSource.reopenRejectedPlanVersion(versionId, reason);
      dispatch({ type: REOPEN_PLAN_VERSION_SUCCESS, payload: result });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.reopenVersionSuccess'),
            severity: 'success',
          },
        },
      });
      return result;
    } catch (error) {
      console.error(error);
      dispatch({ type: REOPEN_PLAN_VERSION_FAILURE, payload: error });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.reopenVersionError'),
            severity: 'error',
          },
        },
      });
      throw error;
    }
  };
}

export function reopenFulfillmentVersion(fulfillmentVersionId: number, reason: string) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: REOPEN_FULFILLMENT_VERSION_REQUEST });
    try {
      const result = await dataSource.reopenRejectedFulfillmentVersion(
        fulfillmentVersionId,
        reason,
      );
      dispatch({ type: REOPEN_FULFILLMENT_VERSION_SUCCESS, payload: result });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.reopenFulfillmentVersionSuccess'),
            severity: 'success',
          },
        },
      });
      return result;
    } catch (error) {
      console.error(error);
      dispatch({ type: REOPEN_FULFILLMENT_VERSION_FAILURE, payload: error });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.reopenFulfillmentVersionError'),
            severity: 'error',
          },
        },
      });
      throw error;
    }
  };
}

export function getPaginatedPlans(
  page: number = 1,
  limit: number = 10,
  sortBy: string = DEFAULT_SORT_BY,
  sortOrder: 'asc' | 'desc' = 'asc',
  filters?: {
    hierarchicalModelId?: string;
    status?: string;
    year?: string;
    fromDate?: string;
    toDate?: string;
    skipDefaultYear?: string;
  },
) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    const requestId = Date.now() + Math.floor(Math.random() * 1000);
    dispatch({ type: GET_PLANS_REQUEST, payload: { requestId } });
    try {
      const response = await dataSource.getPaginatedPlans(
        {
          page,
          limit,
          sortBy,
          sortOrder,
        },
        filters,
      );
      dispatch({ type: GET_PLANS_SUCCESS, payload: { requestId, response } });
    } catch (error) {
      console.error({ error });
      dispatch({ type: GET_PLANS_FAILURE, payload: { error, requestId } });
      const snack = {
        open: true,
        message: t('apiFeedback.plans.paginatedFetchError'),
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function exportAnnualPlansToCSV(filters?: AnnualPlanExportFilters) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: EXPORT_ANNUAL_PLANS_CSV_REQUEST });
    try {
      const blob = await dataSource.exportAnnualPlansToCSV(filters);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'annual_plans.csv';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      dispatch({ type: EXPORT_ANNUAL_PLANS_CSV_SUCCESS });
      const snack = {
        open: true,
        message: t('apiFeedback.plans.exportCsvSuccess'),
        severity: 'success',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    } catch (error) {
      console.error({ error });
      dispatch({ type: EXPORT_ANNUAL_PLANS_CSV_FAILURE, payload: { error } });
      const snack = {
        open: true,
        message: t('apiFeedback.plans.exportCsvError'),
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function exportAnnualPlansToExcel(filters?: AnnualPlanExportFilters) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: EXPORT_ANNUAL_PLANS_EXCEL_REQUEST });
    try {
      const { scopeName } = getState().plans;
      const sanitizeFilenamePart = (value: string) => value.replace(/[\\/:*?"<>|]/g, ' ').trim();
      const safeScopeName = sanitizeFilenamePart(scopeName || '') || 'Ambito';
      const prefixRaw = t('annualPlanning.exportableFilePrefix');
      const exportPrefix =
        prefixRaw && prefixRaw !== 'annualPlanning.exportableFilePrefix'
          ? prefixRaw
          : 'Exportable planes anuales';
      const now = new Date();
      const datePart = [
        now.getFullYear(),
        String(now.getMonth() + 1).padStart(2, '0'),
        String(now.getDate()).padStart(2, '0'),
      ].join('-');
      const timePart = `${String(now.getHours()).padStart(2, '0')}-${String(
        now.getMinutes(),
      ).padStart(2, '0')}`;
      const exportFileName = `${exportPrefix} - ${datePart} ${timePart} - ${safeScopeName}.xlsx`;
      const blob = await dataSource.exportAnnualPlansToExcel(safeScopeName, filters);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = exportFileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      dispatch({ type: EXPORT_ANNUAL_PLANS_EXCEL_SUCCESS });
      const snack = {
        open: true,
        message: t('apiFeedback.plans.exportExcelSuccess'),
        severity: 'success',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    } catch (error) {
      console.error({ error });
      dispatch({ type: EXPORT_ANNUAL_PLANS_EXCEL_FAILURE, payload: { error } });
      const snack = {
        open: true,
        message: t('apiFeedback.plans.exportExcelError'),
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function createFulfillmentVersion(versionId: number) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: CREATE_FULFILLMENT_VERSION_REQUEST });
    try {
      const result = await dataSource.createFulfillmentVersion(versionId);
      dispatch({ type: CREATE_FULFILLMENT_VERSION_SUCCESS, payload: result });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.createFulfillmentVersionSuccess'),
            severity: 'success',
          },
        },
      });
      return result;
    } catch (error) {
      console.error({ error });
      dispatch({ type: CREATE_FULFILLMENT_VERSION_FAILURE, payload: error });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.createFulfillmentVersionError'),
            severity: 'error',
          },
        },
      });
      throw error;
    }
  };
}

export function addFocusDefinitionApproval(
  versionId: number,
  approvalData: CreateFocusDefinitionApprovalInput,
) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: ADD_FOCUS_DEFINITION_APPROVAL_REQUEST });
    try {
      const result = await dataSource.addFocusDefinitionApproval(versionId, approvalData);
      dispatch({ type: ADD_FOCUS_DEFINITION_APPROVAL_SUCCESS, payload: result });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.addFocusDefinitionApprovalSuccess'),
            severity: 'success',
          },
        },
      });
      return result;
    } catch (error) {
      console.error({ error });
      dispatch({ type: ADD_FOCUS_DEFINITION_APPROVAL_FAILURE, payload: error });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.addFocusDefinitionApprovalError'),
            severity: 'error',
          },
        },
      });
      throw error;
    }
  };
}

export function addPlanDefinitionApproval(
  versionId: number,
  approvalData: CreatePlanDefinitionApprovalInput,
) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: ADD_PLAN_DEFINITION_APPROVAL_REQUEST });
    try {
      const result = await dataSource.addPlanDefinitionApproval(versionId, approvalData);
      dispatch({ type: ADD_PLAN_DEFINITION_APPROVAL_SUCCESS, payload: result });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.addPlanDefinitionApprovalSuccess'),
            severity: 'success',
          },
        },
      });
      return result;
    } catch (error) {
      console.error({ error });
      dispatch({ type: ADD_PLAN_DEFINITION_APPROVAL_FAILURE, payload: error });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.addPlanDefinitionApprovalError'),
            severity: 'error',
          },
        },
      });
      throw error;
    }
  };
}

export function getFocusDefinitionApprovals(versionId: number) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: GET_FOCUS_DEFINITION_APPROVALS_REQUEST });
    try {
      const result = await dataSource.getFocusDefinitionApprovals(versionId);
      dispatch({ type: GET_FOCUS_DEFINITION_APPROVALS_SUCCESS, payload: result });
      return result;
    } catch (error) {
      console.error({ error });
      dispatch({ type: GET_FOCUS_DEFINITION_APPROVALS_FAILURE, payload: error });
      throw error;
    }
  };
}

export function getPlanDefinitionApproval(versionId: number) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: GET_PLAN_DEFINITION_APPROVAL_REQUEST });
    try {
      const result = await dataSource.getPlanDefinitionApproval(versionId);
      dispatch({ type: GET_PLAN_DEFINITION_APPROVAL_SUCCESS, payload: result });
      return result;
    } catch (error) {
      console.error({ error });
      dispatch({ type: GET_PLAN_DEFINITION_APPROVAL_FAILURE, payload: error });
      throw error;
    }
  };
}

export function setCurrentVersion(version: number | null) {
  return (dispatch: ThunkAPI['dispatch']) => {
    dispatch({ type: SET_CURRENT_VERSION, payload: { version } });
  };
}

export function setApYear(year: number | null) {
  return (dispatch: ThunkAPI['dispatch']) => {
    dispatch({ type: SET_AP_YEAR, payload: { year } });
  };
}

export function setCurrentBusinessUnit(currentBusinessUnit: string | null) {
  return (dispatch: ThunkAPI['dispatch']) => {
    dispatch({ type: SET_CURRENT_BUSINESS_UNIT, payload: { currentBusinessUnit } });
  };
}

export function setFulfillmentVersion(version: number | null) {
  return (dispatch: ThunkAPI['dispatch']) => {
    dispatch({ type: SET_FULFILLMENT_VERSION, payload: { version } });
  };
}

export function resetPlansState() {
  return (dispatch: ThunkAPI['dispatch']) => {
    dispatch({ type: RESET_PLANS_STATE });
  };
}

export function addFocusFulfillmentValidation(
  fulfillmentVersionId: number,
  validationData: CreateFocusFulfillmentInput,
) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: ADD_FOCUS_FULFILLMENT_VALIDATION_REQUEST });
    try {
      const result = await dataSource.addFocusFulfillmentValidation(
        fulfillmentVersionId,
        validationData,
      );
      dispatch({ type: ADD_FOCUS_FULFILLMENT_VALIDATION_SUCCESS, payload: result });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.addFocusFulfillmentValidationSuccess'),
            severity: 'success',
          },
        },
      });
      return result;
    } catch (error) {
      console.error({ error });
      dispatch({ type: ADD_FOCUS_FULFILLMENT_VALIDATION_FAILURE, payload: error });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.addFocusFulfillmentValidationError'),
            severity: 'error',
          },
        },
      });
      throw error;
    }
  };
}

export function deleteAnnualPlan(planId: number) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: DELETE_ANNUAL_PLAN_REQUEST });
    try {
      await dataSource.deleteAnnualPlan(planId);
      dispatch({ type: DELETE_ANNUAL_PLAN_SUCCESS, payload: { id: planId } });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: { open: true, message: t('apiFeedback.plans.deleteSuccess'), severity: 'success' },
        },
      });
    } catch (error) {
      console.error({ error });
      dispatch({ type: DELETE_ANNUAL_PLAN_FAILURE, payload: error });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: { open: true, message: t('apiFeedback.plans.deleteError'), severity: 'error' },
        },
      });
      throw error;
    }
  };
}

export function addPlanValidation(
  fulfillmentVersionId: number,
  validationData: CreatePlanValidationInput,
) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: ADD_PLAN_VALIDATION_REQUEST });
    try {
      const result = await dataSource.addPlanValidation(fulfillmentVersionId, validationData);
      dispatch({ type: ADD_PLAN_VALIDATION_SUCCESS, payload: result });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.addPlanValidationSuccess'),
            severity: 'success',
          },
        },
      });
      return result;
    } catch (error) {
      console.error({ error });
      dispatch({ type: ADD_PLAN_VALIDATION_FAILURE, payload: error });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.addPlanValidationError'),
            severity: 'error',
          },
        },
      });
      throw error;
    }
  };
}

export function getPlanValidation(fulfillmentVersionId: number) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: GET_PLAN_VALIDATION_REQUEST });
    try {
      const result = await dataSource.getPlanValidation(fulfillmentVersionId);
      dispatch({ type: GET_PLAN_VALIDATION_SUCCESS, payload: result });
      return result;
    } catch (error) {
      console.error({ error });
      dispatch({ type: GET_PLAN_VALIDATION_FAILURE, payload: error });
      return null;
    }
  };
}

export function uploadPlanSignature(fulfillmentVersionId: number, dataUrl: string) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    _getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: 'UPLOAD_PLAN_SIGNATURE_REQUEST' });
    try {
      const result = await dataSource.uploadPlanValidationSignature(fulfillmentVersionId, dataUrl);
      dispatch({ type: 'UPLOAD_PLAN_SIGNATURE_SUCCESS' });
      return result;
    } catch (error) {
      dispatch({ type: 'UPLOAD_PLAN_SIGNATURE_FAILURE', payload: error });
      throw error;
    }
  };
}

export function getFocusFulfillmentValidationsThunk(fulfillmentVersionId: number) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    _getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: GET_FOCUS_FULFILLMENT_VALIDATIONS_REQUEST });
    try {
      const rows = await dataSource.getFocusFulfillmentValidations(fulfillmentVersionId);
      dispatch({ type: GET_FOCUS_FULFILLMENT_VALIDATIONS_SUCCESS, payload: rows });
      return rows;
    } catch (error) {
      dispatch({ type: GET_FOCUS_FULFILLMENT_VALIDATIONS_FAILURE, payload: error });
      return [];
    }
  };
}

export function anularPlanVersion(apId: number) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    _getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: ANULAR_PLAN_VERSION_REQUEST });
    try {
      const result = await dataSource.anularPlanVersion(apId);
      dispatch({ type: ANULAR_PLAN_VERSION_SUCCESS, payload: result });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.anularPlanVersionSuccess'),
            severity: 'success',
          },
        },
      });
      return result;
    } catch (error) {
      console.error({ error });
      dispatch({ type: ANULAR_PLAN_VERSION_FAILURE, payload: error });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.anularPlanVersionError'),
            severity: 'error',
          },
        },
      });
      throw error;
    }
  };
}

export function returnPlanToDefinition(apId: number) {
  return async (
    dispatch: ThunkAPI['dispatch'],
    _getState: ThunkAPI['getState'],
    { services: { dataSource } }: Pick<ThunkAPI, 'services'>,
  ) => {
    dispatch({ type: RETURN_PLAN_TO_DEFINITION_REQUEST });
    try {
      const result = await dataSource.returnPlanToDefinition(apId);
      dispatch({ type: RETURN_PLAN_TO_DEFINITION_SUCCESS, payload: result });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.returnToDefinitionSuccess'),
            severity: 'success',
          },
        },
      });
      return result;
    } catch (error) {
      console.error({ error });
      dispatch({ type: RETURN_PLAN_TO_DEFINITION_FAILURE, payload: error });
      dispatch({
        type: SNACK_SET,
        payload: {
          snack: {
            open: true,
            message: t('apiFeedback.plans.returnToDefinitionError'),
            severity: 'error',
          },
        },
      });
      throw error;
    }
  };
}
